/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Detail_Newbuildindexed2Inputs */

const id_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build baru diindeks`)
};

const ms_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaan baharu diindeks`)
};

const da_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyt build indekseret`)
};

const de_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Build indexiert`)
};

const en_us2_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New build indexed`)
};

const es_es2_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva compilación indexada`)
};

const es_mx2_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva compilación indexada`)
};

const fil_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagong build na na-index`)
};

const fr_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle compilation indexée`)
};

const it_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova build indicizzata`)
};

const hu_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Új build indexelve`)
};

const nl_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe build geïndexeerd`)
};

const no_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ny build indeksert`)
};

const pl_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowa kompilacja zindeksowana`)
};

const pt_br2_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova build indexada`)
};

const pt_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova compilação indexada`)
};

const ro_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilare nouă indexată`)
};

const fi_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uusi koontiversio indeksoitu`)
};

const sv_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nytt bygge indexerat`)
};

const vi_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản dựng mới được lập chỉ mục`)
};

const tr_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni yapı dizine eklendi`)
};

const cs_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nové sestavení indexováno`)
};

const bg_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нова компилация индексирана`)
};

const ru_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новая сборка проиндексирована`)
};

const uk_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нову збірку індексовано`)
};

const ar_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم فهرسة بنية جديدة`)
};

const hi_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया बिल्ड इंडेक्स किया गया`)
};

const th_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บิลด์ใหม่ถูกจัดทำดัชนี`)
};

const ja_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいビルドがインデックスされました`)
};

const zh_cn2_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已索引新构建版本`)
};

const zh_hant1_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已索引新建置版本`)
};

const ko_home_pulse_detail_newbuildindexed2 = /** @type {(inputs: Home_Pulse_Detail_Newbuildindexed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 빌드 인덱싱됨`)
};

/**
* | output |
* | --- |
* | "New build indexed" |
*
* @param {Home_Pulse_Detail_Newbuildindexed2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_detail_newbuildindexed2 = /** @type {((inputs?: Home_Pulse_Detail_Newbuildindexed2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Detail_Newbuildindexed2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "ms") return ms_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "da") return da_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "de") return de_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "en-US") return en_us2_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "fil") return fil_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "fr") return fr_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "it") return it_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "hu") return hu_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "nl") return nl_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "no") return no_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "pl") return pl_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "pt") return pt_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "ro") return ro_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "fi") return fi_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "sv") return sv_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "vi") return vi_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "tr") return tr_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "cs") return cs_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "bg") return bg_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "ru") return ru_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "uk") return uk_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "ar") return ar_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "hi") return hi_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "th") return th_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "ja") return ja_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_detail_newbuildindexed2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_detail_newbuildindexed2(inputs)
	return ko_home_pulse_detail_newbuildindexed2(inputs)
});
export { home_pulse_detail_newbuildindexed2 as "home.pulse.detail.newBuildIndexed" }